var React = require('react');

function Line (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.99885 12.9994C-13.0006 -38.5004 70.5 89.9987 176.5 133.999C241.671 161.051 327.816 178.223 437.499 133.998C510.525 104.554 590.362 12.9994 671.499 12.9994C735.54 12.9994 819.702 110.833 873.999 133.998C957.392 169.576 1025.91 173.204 1056.5 161.999","stroke":"#ECFB70","strokeWidth":"2","strokeDasharray":"10 10"}));
}

Line.defaultProps = {"width":"1057","height":"169","viewBox":"0 0 1057 169","fill":"none"};

module.exports = Line;

Line.default = Line;
